const autoLogin = () => {};

export default autoLogin;
